import { IconProps } from '../icons/types';
import classnames from 'classnames';
import Theme from '../../components-library/Theme';

interface Props extends IconProps {
  type?: 1 | 2;
}

export default function BackIcon({ className, color, style, type = 1 }: Props) {
  if (type === 2) {
    return (
      <svg
        className={classnames('w-6', className)}
        viewBox="0 0 233 419"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        style={style}
      >
        <rect
          y="23.0664"
          width="32.62"
          height="296.072"
          rx="16.31"
          transform="rotate(-45 0 23.0664)"
          fill={color ?? Theme.color.gray['100']}
        />
        <rect
          x="209.422"
          y="185.988"
          width="32.6222"
          height="296.072"
          rx="16.3111"
          transform="rotate(45 209.422 185.988)"
          fill={color ?? Theme.color.gray['100']}
        />
      </svg>
    );
  }

  return (
    <svg className={classnames('w-6', className)} viewBox="0 0 15 24" fill="none" style={style}>
      <path
        d="M4.99492 12L13.463 20.4681C14.271 21.276 14.271 22.586 13.463 23.394C12.655 24.202 11.345 24.202 10.537 23.394L0.605986 13.463C-0.201995 12.655 -0.201995 11.345 0.605986 10.537L10.537 0.605986C11.345 -0.201995 12.655 -0.201995 13.463 0.605986C14.271 1.41397 14.271 2.72396 13.463 3.53194L4.99492 12Z"
        fill={color ?? Theme.color.gray['100']}
      />
    </svg>
  );
}
